export const email = 'lakshitha1629@gmail.com';

export const socials = [
    {
        id: 'linkedin',
        title: 'LinkedIn',
        url: 'https://www.linkedin.com/in/lakshitha1629/',
        icon: 'bxl-linkedin',
    },
    {
        id: 'github',
        title: 'GitHub',
        url: 'https://github.com/lakshitha1629',
        icon: 'bxl-github',
    },
    {
        id: 'medium',
        title: 'Medium',
        url: 'https://medium.com/@lakshitha1629',
        icon: 'bxl-medium',
    },
    {
        id: 'twitter',
        title: 'Twitter',
        url: 'https://twitter.com/lakshitha1629',
        icon: 'bxl-twitter',
    },
];

export const github = {
    profile: 'https://github.com/lakshitha1629',
    username: 'lakshitha1629',
    fallbackPublicRepos: 110,
};

export const resume = {
    local: '/resume/Lakshitha-Perera-Resume.pdf',
    url: 'https://drive.google.com/file/d/1QePsPyedxINA9ULzJid7MSU2y_K80tf1/view?usp=drive_link',
};

export default { email, socials, github, resume };
